import * as service from './service'
export default {
  namespace: 'widgetMallDetail',
  state: {
    saleData: {}
  },
  effects: {
    * getSaleDetail ({ payload }, { call, put }) {
      const res = yield call(service.getSaleDetail, payload)
      yield put({
        type: 'save',
        payload: {
          saleData: res.data
        }
      })
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
